<nwm-menu />
<div class="content">
  <div class="main">
    <div class="row my-4">
      <div class="col-xxl-10 offset-xxl-1">

        <div class="row my-4">
          <div class="col-sm-8 col-lg-8">
            <h1 class="mr-3">{{charityType ? charityType : 'Other'}}</h1>
          </div>
          <div class="col-sm-4 col-lg-4 btns-row">
            <button class="btn-primary sml-btn ml-3 my-1 d-print-none" (click)="openModalToContactAdvisor(pgfModal, 'PgfGrant')" style="height:38px;line-height:36px;">Grant to Charity</button>
            <a onclick="window.print()" class="export-btn d-print-none d-none d-md-inline-block my-1" style="vertical-align:middle">Print</a>
          </div>
        </div>
        <hr>

          <h2 class="mb-3 mt-5">Portion of All Grants Going to This Impact Area</h2>
          <div class="charityBar">
            <div [style.width.%]="charityPercent"><i style="background:#183750"></i></div>
            @if (charityPercent<100) {
              <div [style.width.%]="100-charityPercent"><i style="background:#8799AB"></i></div>
            }
          </div>
          <div class="charityList my-4">
            <div class="d-inline-block py-2 pr-4">
              <i style="background:#183750"></i>
              <p>
                <b>{{charityType ? charityType : 'Other'}}</b><br>
                {{charityPercent | number: '1.2-2'}}% | {{charityAmountCAD | currency:'USD': 'symbol':'1.0-0'}}
              </p>
            </div>
            <div class="d-inline-block py-2">
              <i style="background:#8799AB"></i>
              <p>
                <b>All Other Impact Areas</b><br>
                {{100-charityPercent | number: '1.2-2'}}% | {{inceptionGrants-charityAmountCAD | currency:'USD': 'symbol':'1.0-0'}}
              </p>
            </div>
          </div>

          <h2>Grants to Category Over Time</h2>
          <PGFChart [data]="[yearGrants]" [chartLabels]="chartLabels" />

          <div class="row mb-4 mt-5">
            <div class="col-sm-9">
              <h2 class="mb-3">Grants to Charity in This Impact Area</h2>
              @if (charityType === '' || charityType === 'Other') {
                <p>* This charity is currently classified as 'other' as it has not yet been assigned a category. Our Philanthropy Team is working on it!</p>
              }
            </div>
            <div class="col-sm-3 text-right">
              <select [(ngModel)]="dateRange" (ngModelChange)="filterData()" class="form-control w-auto my-1 ml-3 d-inline-block">
                @for (opt of dateRangeOptions; track opt) {
                  <option [ngValue]="opt.monthsRange">{{opt.text}}</option>
                }
              </select>
            </div>
          </div>
          @if (dataLoaded) {
            <div class="row">
              <div class="col-12">
                <div class="scrollable-wrap">
                  <div class="scrollable">
                    <div class="scrollable-button left"></div>
                    <div class="scrollable-button"></div>
                    <table width="100%" class="NWMtable sticky_header table table-striped mb-0">
                      <thead>
                        <tr>
                          <td role="button" (click)="toggleSort('CharityName')" class="sortable">
                            <span>Charity</span>
                            <i class="fa" [ngClass]="sortField === 'CharityName' ? (sortDir<0 ? 'fa-sort-asc ml-2' : 'fa-sort-desc ml-2') : ''" aria-hidden="true"></i>
                          </td>
                          <td width="160" role="button" class="text-right sortable" (click)="toggleSort('AmountCAD')">
                            <span>Amount</span>
                            <i class="fa" [ngClass]="sortField === 'AmountCAD' ? (sortDir<0 ? 'fa-sort-asc ml-2' : 'fa-sort-desc ml-2') : ''" aria-hidden="true"></i>
                          </td>
                          <td width="40"></td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td class="text-left align-middle">
                            <b>Total as of {{today | date:'MMM d, yyyy'}}</b>
                          </td>
                          <td class="text-right align-middle td-amount">
                            <b>{{total | currency:'USD': 'symbol':'1.0-0' | minusSignToParens}}</b>
                          </td>
                          <td></td>
                        </tr>
                        @if (pagedData && pagedData.length>0) {
                          <ng-container *ngTemplateOutlet="dataList" />
                        }
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="form-inline float-right mb-4">
                  <div class="form-group pt-4">
                    <label for="pageSize" class="font-weight-bold">Rows Displayed</label>
                    <select [(ngModel)]="pageSize" name="pageSize" class="form-control mx-sm-3" id="pageSize" (ngModelChange)="filterData()">
                      <option  [value]="0" [selected]="!pageSize">All</option>
                      @for (o of pageOptions; track o) {
                        <option [value]="o" [selected]="pageSize  === o">{{o}}</option>
                      }
                    </select>
                  </div>
                  @if (totalPages > 1) {
                    <ngb-pagination [collectionSize]="filteredData.length"
                      [(page)]="page" [maxSize]="2" (pageChange)="setPage()"
                      class="pagination pt-4"
                      [pageSize]="pageSize"
                      [boundaryLinks]="true">
                      <ng-template ngbPaginationFirst>First</ng-template>
                      <ng-template ngbPaginationPrevious>Previous</ng-template>
                      <ng-template ngbPaginationNext>Next</ng-template>
                      <ng-template ngbPaginationLast>Last</ng-template>
                    </ngb-pagination>
                  }
                </div>
              </div>
            </div>
          }

        </div>
      </div>
    </div>
  </div>

  <ng-template #dataList>
    @if (pagedData) {
      @for (row of pagedData; track row) {
        <tr>
          <td class="text-left align-middle">
            <button routerLink="/pgf/charity/{{row.CharityId}}" class="charity-button"><span class="charity-button-text">{{row.CharityName}}</span> @if (row.CharityType === '') {
            <span> *</span>
          }</button>
        </td>
        <td class="text-right align-middle td-amount">
          {{row.AmountCAD | currency:'USD': 'symbol':'1.0-0' | minusSignToParens}}
          <ng-container *ngTemplateOutlet="usdIcon;context:row" />
        </td>
        <td>
          @if (row.SpecialMessage !== '') {
            <span class="material-icons" [ngbTooltip]="row.SpecialMessage" container="body">description</span>
          }
        </td>
      </tr>
    }
  }
</ng-template>

<ng-template #pgfModal let-modal>
  <nwm-advisor-contact [formAction]="modalAction" [formTitle]="modalTitle" (formCancelled)="modal.close()" />
</ng-template>

<ng-template #usdIcon let-currency="TransactionCurrency" let-amount="AmountUSD">
  @if (currency === 'USD') {
    <span class="usdIcon material-icons" ngbTooltip="{{amount | currency:'USD': 'symbol':'1.0-0' | minusSignToParens}}" container="body">
      swap_horiz
    </span>
  }
</ng-template>
